import React, { useMemo } from 'react';
import { generateButtonStyles } from 'shared-components/Button/Button.styles';
import { useTheme } from '@emotion/react';
import { Box } from '@mui/material';

type Props = {
    children: React.ReactNode;
    onClick?: () => void;
};

export function Button({ children, onClick }: Props) {
    const theme = useTheme();
    const styles = useMemo(() => generateButtonStyles(theme), [theme]);

    return (
        <Box component="button" type="button" sx={styles.btn} onClick={onClick || (() => {})}>
            {children}
        </Box>
    );
}
